import React, { Component } from 'react';
import utilMobile from "../commons/MobileGeneralFunctions"
import constants from "../commons/MobileFormsConstants"
import listService from '../../service/ListService';

class MobileMargins extends Component {

    constructor(props) {
        super(props);
    }

    createMarginContainer(marginSize) {
        let container = document.createElement('div');
        container.style.height = `${marginSize}px`;
        container.style.width = '100%';
        container.style.display = 'table';
        container.draggable = false;
        container.className = constants.MOBILE_ROW_MARGIN;
        container.id = this.createGuid();
        return container;
    }

    createGuid(flag = 10) {
        let result = this.random();
        for (let i = 0; i <= flag; i++) {
            result += (this.random());
        }
        return result;
    }

    setMargins(id, container) {
        let obj = listService.getMobileObject(id);

        if (obj) {
            let marginSize = utilMobile.GetDefaultMarginByFactoryKey(constants.MARGIN_KEY).marginSize;
            if (obj.margins.top > 0) {
                container.insertBefore(this.createMarginContainer(marginSize), container.firstChild);
            }
            if (obj.margins.bottom > 0) {
                container.appendChild(this.createMarginContainer(marginSize));
            }
        }
    }

    changeMarginSize(marginSize){
        listService.mobileObjects.forEach(object => {
            if (object.margins.top > 0) {
                object.margins.top = marginSize;
            }
            if (object.margins.bottom > 0) {
                object.margins.bottom = marginSize;
            }
        });
    }

    updateMarginSize(currentSelection, factoryKey) {
        let size = (currentSelection) ? currentSelection.value : listService.mobileStyles().get(factoryKey).marginSize;
        if (factoryKey === constants.MARGIN_KEY) {
            let dropzone = document.querySelector('.dropzone');
            let margins = Array.from(dropzone.querySelectorAll(`.${constants.MOBILE_ROW_MARGIN}`));
            if (margins) {
                margins.forEach(margin => { margin.style.height = `${size}px`;});
                this.changeMarginSize(size);
                listService.updateMarginSizeByKey(constants.MARGIN_KEY, size.toString());
            }
        }
    }

    showHideMargins(container, show) {
        let margins = Array.from(container.querySelectorAll(`.${constants.MOBILE_ROW_MARGIN}`));

        margins.forEach(margin => {
            margin.style.backgroundColor = "";
            margin.style.border = "";

            if (show) {
                margin.style.backgroundColor = "#cc7929";
                margin.style.opacity = "0.6";
                margin.style.border = "1px solid #cc7929";
            }
        });
    }

    resetDOMMargins(container) {
        let margins = container.getElementsByClassName(constants.MOBILE_ROW_MARGIN);
        while (margins[0]) {
            margins[0].parentNode.removeChild(margins[0]);
        }
    }

    getDefaultMarginsSize() {
        let defaultSizeSelector = document.getElementsByName("Margin");
        return defaultSizeSelector[0].selectedOptions[0].value;
    }

    selectMarginOption(contextMenu, obj) {

        let options = Array.from(contextMenu.querySelectorAll(".mobile-margin"));

        options.forEach(option => {
            option.style.border = "";
        });

        let selectedOption = this.getSelectedOption(obj, 0);
        const primaryColor = localStorage.getItem("primaryColor") || '#799f2c';
        let currentOption = document.getElementById("mobile-wizard-option-" + selectedOption);
        currentOption.style.border = "2px solid " + primaryColor;
    }

    getSelectedOption(obj, defaultVal){
        let selectedOption = "none";

        if (obj && obj.margins) {
            if (obj.margins.top > defaultVal) {
                selectedOption = "top";
            }
            if (obj.margins.bottom > defaultVal) {
                if (selectedOption !== "none") {
                    selectedOption += "-bottom";
                }
                else {
                    selectedOption = "bottom";
                }
            }
        }
        return selectedOption;
    }
}

export default new MobileMargins;